import * as Types from '../types.generated'

import { gql } from '@apollo/client'
import { ConsortiumDetailsFragmentDoc } from '../fragments/ConsortiumDetails.generated'
import { ConsortiumsListFragmentDoc } from '../fragments/ConsortiumsList.generated'
import * as Apollo from '@apollo/client'
const defaultOptions = {} as const
export const GetPaginatedConsortiumsFromFirstFragmentDoc = gql`
  fragment getPaginatedConsortiumsFromFirst on Query {
    fromFirst: consortiums(first: $limit, after: $cursor, text: $text, frameworks: $frameworks) {
      ...ConsortiumsList
    }
  }
  ${ConsortiumsListFragmentDoc}
`
export const GetPaginatedConsortiumsFromLastFragmentDoc = gql`
  fragment getPaginatedConsortiumsFromLast on Query {
    fromLast: consortiums(last: $limit, before: $cursor, text: $text, frameworks: $frameworks) {
      ...ConsortiumsList
    }
  }
  ${ConsortiumsListFragmentDoc}
`
export const GetConsortiumBySlugDocument = gql`
  query GetConsortiumBySlug($slug: String!) {
    consortium(slug: $slug) {
      ...ConsortiumDetails
    }
  }
  ${ConsortiumDetailsFragmentDoc}
`

/**
 * __useGetConsortiumBySlugQuery__
 *
 * To run a query within a React component, call `useGetConsortiumBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsortiumBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsortiumBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetConsortiumBySlugQuery(baseOptions: Apollo.QueryHookOptions<GetConsortiumBySlugQuery, GetConsortiumBySlugQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetConsortiumBySlugQuery, GetConsortiumBySlugQueryVariables>(GetConsortiumBySlugDocument, options)
}
export function useGetConsortiumBySlugLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetConsortiumBySlugQuery, GetConsortiumBySlugQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetConsortiumBySlugQuery, GetConsortiumBySlugQueryVariables>(GetConsortiumBySlugDocument, options)
}
export type GetConsortiumBySlugQueryHookResult = ReturnType<typeof useGetConsortiumBySlugQuery>
export type GetConsortiumBySlugLazyQueryHookResult = ReturnType<typeof useGetConsortiumBySlugLazyQuery>
export type GetConsortiumBySlugQueryResult = Apollo.QueryResult<GetConsortiumBySlugQuery, GetConsortiumBySlugQueryVariables>
export const GetPaginatedConsortiumsDocument = gql`
  query getPaginatedConsortiums($limit: Int, $cursor: Cursor, $text: String, $frameworks: [String!], $isFromFirst: Boolean!) {
    ...getPaginatedConsortiumsFromFirst @include(if: $isFromFirst)
    ...getPaginatedConsortiumsFromLast @skip(if: $isFromFirst)
  }
  ${GetPaginatedConsortiumsFromFirstFragmentDoc}
  ${GetPaginatedConsortiumsFromLastFragmentDoc}
`

/**
 * __useGetPaginatedConsortiumsQuery__
 *
 * To run a query within a React component, call `useGetPaginatedConsortiumsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedConsortiumsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedConsortiumsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *      text: // value for 'text'
 *      frameworks: // value for 'frameworks'
 *      isFromFirst: // value for 'isFromFirst'
 *   },
 * });
 */
export function useGetPaginatedConsortiumsQuery(
  baseOptions: Apollo.QueryHookOptions<GetPaginatedConsortiumsQuery, GetPaginatedConsortiumsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetPaginatedConsortiumsQuery, GetPaginatedConsortiumsQueryVariables>(GetPaginatedConsortiumsDocument, options)
}
export function useGetPaginatedConsortiumsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPaginatedConsortiumsQuery, GetPaginatedConsortiumsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetPaginatedConsortiumsQuery, GetPaginatedConsortiumsQueryVariables>(GetPaginatedConsortiumsDocument, options)
}
export type GetPaginatedConsortiumsQueryHookResult = ReturnType<typeof useGetPaginatedConsortiumsQuery>
export type GetPaginatedConsortiumsLazyQueryHookResult = ReturnType<typeof useGetPaginatedConsortiumsLazyQuery>
export type GetPaginatedConsortiumsQueryResult = Apollo.QueryResult<GetPaginatedConsortiumsQuery, GetPaginatedConsortiumsQueryVariables>
export type GetConsortiumBySlugQueryVariables = Types.Exact<{
  slug: Types.Scalars['String']
}>

export type GetConsortiumBySlugQuery = {
  __typename?: 'Query'
  consortium?: {
    __typename?: 'Consortium'
    id: string
    name: string
    description: string
    slug: string
    socialUrls: Array<{ __typename?: 'SocialURL'; type: Types.SocialUrlType; url: string }>
    organizations: Array<{
      __typename?: 'Organization'
      id: string
      name: string
      description: string
      slug: string
      logo?: { __typename?: 'LogoInformation'; url: string; isBright: boolean } | null
    }>
    frameworks: Array<{ __typename?: 'BlockchainFramework'; name: string }>
    logo?: { __typename?: 'LogoInformation'; url: string; isBright: boolean } | null
  } | null
}

export type GetPaginatedConsortiumsFromFirstFragment = {
  __typename?: 'Query'
  fromFirst: {
    __typename?: 'ConsortiumConnection'
    edges: Array<{
      __typename?: 'ConsortiumEdge'
      cursor: any
      node: {
        __typename?: 'Consortium'
        id: string
        name: string
        description: string
        slug: string
        frameworks: Array<{ __typename?: 'BlockchainFramework'; name: string }>
        logo?: { __typename?: 'LogoInformation'; url: string; isBright: boolean } | null
      }
    }>
    pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; startCursor?: any | null; hasPreviousPage: boolean; endCursor?: any | null }
  }
}

export type GetPaginatedConsortiumsFromLastFragment = {
  __typename?: 'Query'
  fromLast: {
    __typename?: 'ConsortiumConnection'
    edges: Array<{
      __typename?: 'ConsortiumEdge'
      cursor: any
      node: {
        __typename?: 'Consortium'
        id: string
        name: string
        description: string
        slug: string
        frameworks: Array<{ __typename?: 'BlockchainFramework'; name: string }>
        logo?: { __typename?: 'LogoInformation'; url: string; isBright: boolean } | null
      }
    }>
    pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; startCursor?: any | null; hasPreviousPage: boolean; endCursor?: any | null }
  }
}

export type GetPaginatedConsortiumsQueryVariables = Types.Exact<{
  limit?: Types.InputMaybe<Types.Scalars['Int']>
  cursor?: Types.InputMaybe<Types.Scalars['Cursor']>
  text?: Types.InputMaybe<Types.Scalars['String']>
  frameworks?: Types.InputMaybe<Array<Types.Scalars['String']> | Types.Scalars['String']>
  isFromFirst: Types.Scalars['Boolean']
}>

export type GetPaginatedConsortiumsQuery = {
  __typename?: 'Query'
  fromFirst: {
    __typename?: 'ConsortiumConnection'
    edges: Array<{
      __typename?: 'ConsortiumEdge'
      cursor: any
      node: {
        __typename?: 'Consortium'
        id: string
        name: string
        description: string
        slug: string
        frameworks: Array<{ __typename?: 'BlockchainFramework'; name: string }>
        logo?: { __typename?: 'LogoInformation'; url: string; isBright: boolean } | null
      }
    }>
    pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; startCursor?: any | null; hasPreviousPage: boolean; endCursor?: any | null }
  }
  fromLast: {
    __typename?: 'ConsortiumConnection'
    edges: Array<{
      __typename?: 'ConsortiumEdge'
      cursor: any
      node: {
        __typename?: 'Consortium'
        id: string
        name: string
        description: string
        slug: string
        frameworks: Array<{ __typename?: 'BlockchainFramework'; name: string }>
        logo?: { __typename?: 'LogoInformation'; url: string; isBright: boolean } | null
      }
    }>
    pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; startCursor?: any | null; hasPreviousPage: boolean; endCursor?: any | null }
  }
}
